import React from "react";

import { Formik, Field, Form } from "formik";

import { db, auth } from "../lib/firebaseCompat";
import Layout from "../components/shared/Layout";
import Loading from "../components/shared/Loading";
import InputField from "../components/shared/InputField";
import CardPanel from "../components/shared/CardPanel";
import CardHeader from "../components/shared/CardHeader";
import CardTitle from "../components/shared/CardSearchTable/Title";
import Row from "../components/shared/Row";

import { useMaterialInputFields } from "../hooks/useMaterialInputFields";
import { useAuth } from "../hooks/usehooks.com/use-auth";

const EditUserForm = () => {
  useMaterialInputFields();
  const auth = useAuth();
  const { user } = auth;
  const { displayName, email } = user;

  const handleSubmitUser = async ({ displayName }) => {
    // update firebase auth user
    await user.updateProfile({ displayName });
    // update firestore user
    const doc = db.collection("users").doc(user.uid);
    await doc.update({ displayName });
    M.toast({ html: "User updated successfully!" });
  };

  const handleSubmitLogin = async (
    { email, password, newPassword },
    { setFieldValue }
  ) => {
    try {
      const credential = auth.EmailAuthProvider.credential(
        user.email,
        password
      );
      await user.reauthenticateWithCredential(credential);

      try {
        if (email !== user.email) {
          await user.updateEmail(email);
          await user.sendEmailVerification();
        }
        if (newPassword) {
          await user.updatePassword(newPassword);
          setFieldValue("password", "");
          setFieldValue("newPassword", "");
        }
        M.toast({ html: "Login Updated Successfully!" });
      } catch (err) {
        console.error(err);
        M.toast({ html: "There was an error updating the user" });
      }
    } catch (err) {
      M.toast({ html: "Incorrect Current Password" });
    }
  };

  return (
    <>
      <Formik initialValues={{ displayName }} onSubmit={handleSubmitUser}>
        <Form autoComplete="off">
          <CardHeader text="User Information" icon="person" />
          <Row>
            <InputField
              name="displayName"
              label="Display Name"
              size="s12"
              required
            />
          </Row>
          <div className="right-align">
            <button type="submit" className="btn green">
              Update User
            </button>
          </div>
        </Form>
      </Formik>

      <Formik
        initialValues={{ email, password: "", newPassword: "" }}
        onSubmit={handleSubmitLogin}
      >
        <Form autoComplete="off">
          <CardHeader text="Login Information" icon="lock" />
          <Row>
            <InputField
              name="email"
              label="Email"
              type="email"
              size="s12"
              required
            />
          </Row>
          <Row>
            <InputField
              name="password"
              type="password"
              label="Current Password"
            />
            <InputField
              name="newPassword"
              type="password"
              label="New Password"
              autoComplete="new-password"
            />
          </Row>
          <div className="right-align">
            <button type="submit" className="btn green">
              Update Login
            </button>
          </div>
        </Form>
      </Formik>
    </>
  );
};

export default function EditUser() {
  const auth = useAuth();

  return (
    <Layout>
      <CardPanel>
        <CardTitle
          header="Edit Your Account"
          tooltip="Edit your account's details."
        />
        <br />
        {!auth.user ? <Loading /> : <EditUserForm />}
      </CardPanel>
    </Layout>
  );
}
